// extracted by mini-css-extract-plugin
export default {"value":"_7nu9zTS","with-padding":"f8Kbq1gf","centered":"xYPi6uyJ","component":"GWP459jv"};